import React from "react";
import moment from "moment";
import { Slide, toast, Zoom } from "react-toastify";
import {
  CheckCircleFilled,
  SyncOutlined,
  CloseOutlined,
  InfoCircleOutlined,
  WarningOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Col, Row, Progress, Typography, Spin } from "antd";
const { Text } = Typography;

// const renderIcon = (type) => {
//   switch (type) {
//     case 'success':
//       return <CheckCircleFilled style={{ fontSize: '28px' }} />
//     case 'error':
//       return <CloseOutlined />
//     case 'warn':
//       return <WarningOutlined />

//     case 'info':
//       return <InfoCircleOutlined />
//     default:
//       break
//   }
// }

// const renderMessage = (message, type: any) => {
//   return (
//     <div className={`custom-notification custom-noti-${type}`}>
//       <Row>
//         <Col span={3} style={{ display: 'flex' }}>
//           {renderIcon(type)}
//         </Col>
//         <Col span={21}>
//           <div>
//             <h4 className="heading">{type}</h4>
//           </div>
//           <p className="noti-content">{message}</p>
//         </Col>
//       </Row>
//     </div>
//   )
// }

// export function showNotyError(message, afterClose, id) {
//   toast(renderMessage(message, 'error'), {
//     onClose: afterClose,
//     toastId: id,
//     transition: Slide,
//     position: 'top-right',
//     className: 'auto-error',
//   })
// }

// export function showNotyMaskWarning(message, afterClose, id) {
//   toast(renderMessage(message, 'error'), {
//     onClose: afterClose,
//     toastId: id,
//     transition: Slide,
//     position: 'top-right',
//     className: 'auto-error',
//   })
// }

// export function showNotyAutoError(message, afterClose, id) {
//   toast(renderMessage(message, 'error'), {
//     autoClose: 3000,
//     onClose: afterClose,
//     toastId: id,
//     transition: Slide,
//     position: 'top-right',
//     className: 'auto-error',
//   })
// }

// export function showNotyWarning(message, afterClose) {
//   toast.warn(renderMessage(message, 'warn'), {
//     autoClose: 3000,
//     onClose: afterClose,
//     transition: Slide,
//     position: 'top-right',
//   })
// }

// export function showNotyInfo(message) {
//   toast(renderMessage(message, 'success'), {
//     autoClose: 3000000,
//     transition: Slide,
//     position: 'top-right',
//     className: 'auto-success',
//   })
// }

const renderIcon = (type) => {
  switch (type) {
    case "success":
      return <CheckCircleFilled className="cpr-notify icon-big" />;
    case "error":
      return <CloseOutlined className="cpr-notify icon-big" />;
    case "warning":
      return <WarningOutlined className="cpr-notify icon-big" />;
    case "info":
      return <InfoCircleOutlined className="cpr-notify icon-big" />;
    case "uploading":
      // return <SyncOutlined className="cpr-notify icon-big" />;
      return (
        <Spin
          className="cpr-notify icon-big"
          indicator={<LoadingOutlined spin />}
          size="large"
        />
      );
    default:
      break;
  }
};

export const renderMessage = (message, type, customHeading, progress) => {
  const variant =
    type === "success" ? "#74b607" : type === "error" ? "#f5222d" : "info";
  const variant1 =
    type === "success" ? "active" : type === "error" ? "exception" : "active";
  return (
    <div className={`custom-notification custom-noti-${type}`}>
      {renderIcon(type)}
      <div>
        <h4 className="heading">{customHeading ? customHeading : type}</h4>
      </div>
      {progress === null && <Text className="noti-content">{message}</Text>}

      {/* {progress && <ProgressBar striped variant={variant} animated now={progress} label={`${progress}%`} />} */}
      {progress && (
        <Progress
          percent={progress}
          strokeColor={variant}
          status={progress === 100 ? "success" : "active"}
        />
      )}
    </div>
  );
};

export function showNotyError(message) {
  toast(renderMessage(message, "error", "Error Notification", null), {
    // onClose: afterClose,
    // toastId: id,
    transition: Slide,
    position: "top-right",
    className: "auto-error",
  });
}

export function showNotyMaskWarning(message, afterClose, id) {
  toast(renderMessage(message, "error", "Project Masked", 344), {
    onClose: afterClose,
    toastId: id,
    transition: Slide,
    position: "top-right",
    className: "auto-error",
  });
}

export function showNotyAutoError(message) {
  toast(renderMessage(message, "error", "Error Notification", null), {
    autoClose: 3000,
    // onClose: afterClose,
    // toastId: id,

    transition: Slide,
    position: "top-right",
    className: "auto-error",
  });
}

export function showNotyWarning(message, afterClose) {
  toast.warn(renderMessage(message, "warning", "Warning Notification", null), {
    autoClose: 3000,
    transition: Slide,
    position: "top-right",
    className: "auto-warning",
  });
}

export function showNotyInfo(message) {
  toast(renderMessage(message, "info", "Info Notification", null), {
    autoClose: 3000,
    // onClose: afterClose,
    transition: Slide,
    position: "top-right",
    className: "auto-info",
  });
}

export function showNotySucess(message) {
  toast(renderMessage(message, "success", "Success Notification", null), {
    autoClose: 3000,
    transition: Slide,
    position: "top-right",
    className: "auto-success",
  });
}
